import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faCalendarAlt, faDollarSign, faHashtag, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        client_id: '',
        client_name: '',
        client_address: '',
        client_phone: '',
        initial_date: '',
        due_date: '',
        system_type: '',
        client_price: '',
        consultant_price: '',
        final_price: '',
        commission: '',
        details: '',
        status: '',
        errors: [],
    }
    changeValue = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errors: [] })
    }
    errorVerify(element) {
        return this.state.errors.indexOf(element) !== -1;
    }
    sendData = (e) => {
        e.preventDefault();
        const { client_id, client_name, client_address, client_phone, initial_date, due_date, system_type, client_price, consultant_price, final_price, commission, details, status } = this.state;
        var errors = [];
        if (!client_id) { errors.push("error_client_id"); }
        if (!client_name) { errors.push("error_client_name"); }
        if (!client_address) { errors.push("error_client_address"); }
        if (!client_phone) { errors.push("error_client_phone"); }
        if (!initial_date) { errors.push("error_initial_date"); }
        if (!due_date) { errors.push("error_due_date"); }
        if (!system_type) { errors.push("error_system_type"); }
        if (!client_price) { errors.push("error_client_price"); }
        if (!consultant_price) { errors.push("error_consultant_price"); }
        if (!final_price) { errors.push("error_final_price"); }
        if (!commission) { errors.push("error_commission"); }
        if (!status) { errors.push("error_status"); }
        console.log(errors.length);
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }
        var data = {
            client_id: client_id,
            client_name: client_name,
            client_address: client_address,
            client_phone: client_phone,
            initial_date: initial_date,
            due_date: due_date,
            system_type: system_type,
            client_price: client_price,
            consultant_price: consultant_price,
            final_price: final_price,
            commission: commission,
            details: details,
            status: status,
            user_id: window.localStorage.getItem('idusuario')
        }
        Swal.showLoading();
        authAxios.post("sales/register", data)
            .then((dataResult) => {
                console.log(dataResult)
                var status = dataResult.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token has Expired!', 'Re-Login', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (dataResult.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Sales!',
                        dataResult.data.msj,
                        'success'
                    )
                    this.props.history.push("/MasterSales");
                } else {
                    Swal.close();
                    Swal.fire(
                        'Sales!',
                        dataResult.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    componentDidMount() {
        Swal.showLoading();
        Swal.close();
    }
    render() {
        const { client_id, client_name, client_address, client_phone, initial_date, due_date, system_type, client_price, consultant_price, final_price, commission, details, status } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>NEW SALE</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.sendData}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <hr style={{ marginBottom: 0, marginTop: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>CLIENT INFORMATION</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="client_id">Client ID.</label>
                                                    <div className={((this.errorVerify("error_client_id")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.errorVerify("error_client_id")) ? "is-invalid" : "") + " form-control form-control-sm"} type="number" name="client_id" id="client_id" value={client_id} placeholder="Client ID." aria-describedby="helpId" onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Client ID.</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-5">
                                                    <label htmlFor="client_name">Client Name</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.errorVerify("error_client_name")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="client_name" id="client_name" value={client_name} placeholder="Client Name" aria-describedby="helpId" onChange={this.changeValue} />
                                                    <small id="helpId" className="invalid-feedback">Please enter Client Name</small>
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="client_address">Client Address</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.errorVerify("error_client_address")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="client_address" id="client_address" value={client_address} placeholder="Client Address" aria-describedby="helpId" onChange={this.changeValue} />
                                                    <small id="helpId" className="invalid-feedback">Please enter Client Address</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="client_phone">Client Phone</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.errorVerify("error_client_phone")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="client_phone" id="client_phone" value={client_phone} placeholder="Client Phone" aria-describedby="helpId" onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Client Phone</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>SALE INFORMATION</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="initial_date">Initial Date</label>
                                                    <div className={((this.errorVerify("error_initial_date")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="initial_date" id="initial_date" value={initial_date}
                                                            className={((this.errorVerify("error_initial_date")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Initial Date" aria-describedby="helpId"
                                                            onChange={this.changeValue}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please choose Initial Date</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="due_date">Due Date</label>
                                                    <div className={((this.errorVerify("error_due_date")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="due_date" id="due_date" value={due_date}
                                                            className={((this.errorVerify("error_due_date")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Due Date" aria-describedby="helpId"
                                                            onChange={this.changeValue}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please choose Due Date</small>
                                                </div>
                                                <div className="col-md-6"></div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="status">Status</label>
                                                    <select name="status"
                                                        id="status"
                                                        className={((this.errorVerify("error_status")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.changeValue}>
                                                        <option value="">Select Status</option>
                                                        <option value="1">PAID</option>
                                                        <option value="2">PENDING</option>
                                                        <option value="3">FAILED</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Please choose Status</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="system_type">System Type</label>
                                                    <div className={((this.errorVerify("error_system_type")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="system_type" id="system_type" defaultValue={system_type}
                                                            className={((this.errorVerify("error_system_type")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="System Type" aria-describedby="helpId"
                                                            onChange={this.changeValue}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter System Type</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="client_price">Client Price (KW)</label>
                                                    <div className={((this.errorVerify("error_client_price")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="client_price" id="client_price" defaultValue={client_price}
                                                            className={((this.errorVerify("error_client_price")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Client Price (KW)" aria-describedby="helpId"
                                                            onChange={this.changeValue}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Client Price (KW)</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="consultant_price">Consultant Price (KW)</label>
                                                    <div className={((this.errorVerify("error_consultant_price")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="consultant_price" id="consultant_price" defaultValue={consultant_price}
                                                            className={((this.errorVerify("error_consultant_price")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Consultant Price (KW)" aria-describedby="helpId"
                                                            onChange={this.changeValue}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Cons. Price (KW)</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="final_price">Final Price</label>
                                                    <div className={((this.errorVerify("error_final_price")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="final_price" id="final_price" defaultValue={final_price}
                                                            className={((this.errorVerify("error_final_price")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Final Price" aria-describedby="helpId"
                                                            onChange={this.changeValue}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Final Price</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="commission">Sale Commission</label>
                                                    <div className={((this.errorVerify("error_commission")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="commission" id="commission" defaultValue={commission}
                                                            className={((this.errorVerify("error_commission")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Sale Commission" aria-describedby="helpId"
                                                            onChange={this.changeValue}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Sale Commission</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-12">
                                                    <label htmlFor="details">Details</label>
                                                    <textarea style={{ resize: 'none', textTransform: 'uppercase' }} className='form-control form-control-sm' id="details" name="details" rows='3' onChange={this.changeValue} aria-describedby="helpId"></textarea>
                                                    <small id="helpId" className="invalid-feedback">Please enter Details</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Save</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterSales"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancel</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;